export const BASE_URL = "https://booksapi.zarpsoftware.in/api";
export const AuthURL = "https://booksapi.zarpsoftware.in/auth";

//export NODE_OPTIONS="--openssl-legacy-provider --max-old-space-size=12288";
